import { Component, OnInit,Inject,OnDestroy, Input } from '@angular/core';
import { ObservablesService } from '../observables.service';
import { ApiService } from '../api.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  action:boolean;
  message:any;
  data:any;
}
@Component({
  selector: 'app-user-sidenav',
  templateUrl: './user-sidenav.component.html',
  styleUrls: ['./user-sidenav.component.scss']
})
export class UserSidenavComponent implements OnInit {
  loggedUserInfo:any=[];
  dataForm:FormGroup;
  closeResult: string;
  h_level:any=[];
  profileUpdateSubscriber:any;
  constructor(public dialog: MatDialog,private router:Router,private api:ApiService, private observables:ObservablesService,private modalService: NgbModal,private fb:FormBuilder) { }
  ngOnDestroy(){
    this.profileUpdateSubscriber.unsubscribe()
  }

  ngOnInit() {
    this.profileUpdateSubscriber = this.observables.profileUpdateStatus.subscribe(()=>{
      this.api.getLoggedUserInfo().then((res:any)=>{
        // console.log("res=",res)
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];

        }else{
          this.api.logOut()
        }
      })
    })
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log("res=",res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];

      }else{
        this.api.logOut()
      }
    })
  }

  closeMenu(){
    // console.log('called me')
    this.observables.setMenuStatus({menuState:'out'})
  }


    profile(){
      this.closeMenu()
      let dialogConfig:any;

        dialogConfig = {
          panelClass: 'profile-popup',
          width: '50vw',
          height: '80vh',
          data: {action:true,data:this.loggedUserInfo,message:"User Profile"}
        }

     const dialogRef = this.dialog.open(UserProfileComponent,dialogConfig);

     dialogRef.afterClosed().subscribe(result => {
       // console.log(`Dialog result: ${result}`);

     });
    }



  logOut(){
    this.closeMenu();
    localStorage.clear();
    localStorage.setItem("logOutStatus",'1')
    // this.observables.logout();
    this.router.navigate(['/login']);
  }

  addItem(){
    this.closeMenu();
    this.router.navigate(['/user/add-item'])
  }

  addTags(){
    this.closeMenu();
    this.observables.tagPopupStatus.next()
  }



  changePassword(){
    this.closeMenu();

    this.observables.changePasswordStatus.next()
    // this.observables.showPopupStatus.next({changePasswordStatus:true})
  }


  gotoReport(){
    this.closeMenu();
    // this.observables.setPage({page:'report',data:{}});
  }

}


@Component({
  selector: 'app-profile',
  templateUrl: '../profile/profile.component.html'
})
export class UserProfileComponent {
  profileData:any
  message:any
  profileForm:FormGroup;
  constructor(private observables:ObservablesService, private fb:FormBuilder, private api:ApiService,public dialog: MatDialog,public dialogRef: MatDialogRef<UserProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    ngOnInit() {
      // console.log("data in profile dialog=",this.data)
      this.profileData = this.data.data;
      this.message = this.data.message
      this.profileForm = this.fb.group({
        business_id:[this.profileData.business_id, Validators.required],
        business_name:[{value:this.profileData.business_name,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        business_mobile:[{value:this.profileData.business_mobile,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        address:[{value:this.profileData.address,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        city:[{value:this.profileData.city,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        state:[{value:this.profileData.state,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        pincode:[{value:this.profileData.pincode,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        gstin:[{value:this.profileData.gstin,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        full_name:[this.profileData.full_name, Validators.required],
        mobile:[this.profileData.mobile, Validators.required],
      })
    }

    save(){

      let value = this.profileForm.getRawValue();
      // console.log("value==",value)


        if(value.mobile != this.profileData.mobile || value.full_name !=this.profileData.full_name){


          if(confirm("Are you sure to update profile details ?")){

            this.updateUserData(value)

          }

        }else{
          this.observables.showToastMessage({type:0,message:"No changes Detected"})
        }

    }

    updateUserData(value){
      this.api.send("updateDb",{
        table:"users",
        data:{
          full_name:value.full_name,
          mobile:value.mobile
        },
        conditions:[{id:this.profileData.id,business_id:this.profileData.business_id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0,message:"Profile Updated"})
          this.dialogRef.close()
          this.observables.profileUpdateStatus.next()
        }else{

          this.observables.showToastMessage({type:1,message:"Some Problem Occured, Profile Not Updated"})
        }
      })
    }

  }
